// header
if (document.body.clientWidth > 767) {
  $(window).scroll(function(){
      if ($(window).scrollTop() >= 200) {
          $('nav').addClass('fixed-header');
          $('nav div').addClass('visible-title');
      }
      else {
          $('nav').removeClass('fixed-header');
          $('nav div').removeClass('visible-title');
      }
  });
}else{
  $('nav').addClass('fixed-header');
  $('nav div').addClass('visible-title');
}

setTimeout(() => {
  document.querySelector('#loading-frame').style.display = 'none'
}, 5000);


// WEBPACK FOOTER //
// ./src/lib/app/js/background.js